<template lang="pug">
    .row
        .entry-wrapper(v-if="entry")
            .slice-image(v-if="entry.image", :style="cssBackground")
            .slice
                h1 {{entry.title.rendered}}
                hr
            .slice
                .page(v-html="entry.content.rendered")
</template>

<script>
import Api from './services/Api'

export default {
  name: 'NewsEntry',
  data() {
    return {
      entry: null,
      slug: null,
      cssBackground: {
        background: null,
      },
    }
  },
  created() {
    this.loadContent(this.$route.params.slug)
  },
  methods: {
    loadContent(slug) {
      const _this = this
      const token = this.$store.state.token

      Api.getEntry(slug, token)
        .then(response => {
          _this.slug = slug
          _this.entry = response.data
          if (_this.entry.image)
            _this.cssBackground.background = `url(${_this.entry.image}) no-repeat center center`
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        .catch()
    },
  },
  watch: {
    $route(to, from) {
      this.loadContent(to.params.slug)
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
@import './NewsEntry';
</style>



// WEBPACK FOOTER //
// src/components/NewsEntry.vue